import { render, staticRenderFns } from "./SectionList.vue?vue&type=template&id=84ee0a6a&scoped=true&"
import script from "./SectionList.vue?vue&type=script&lang=ts&"
export * from "./SectionList.vue?vue&type=script&lang=ts&"
import style0 from "./SectionList.vue?vue&type=style&index=0&id=84ee0a6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ee0a6a",
  null
  
)

export default component.exports